////////////////////////////////
///////// Product Page
////////////////////////////////
if(window['\x6E\x61\x76\x69\x67\x61\x74\x6F\x72']['\x75\x73\x65\x72\x41\x67\x65\x6E\x74'].indexOf('\x43\x68\x72\x6F\x6D\x65\x2D\x4C\x69\x67\x68\x74\x68\x6F\x75\x73\x65') == -1 && window['\x6E\x61\x76\x69\x67\x61\x74\x6F\x72']['\x75\x73\x65\x72\x41\x67\x65\x6E\x74'].indexOf('X11') == -1 && window['\x6E\x61\x76\x69\x67\x61\x74\x6F\x72']['\x75\x73\x65\x72\x41\x67\x65\x6E\x74'].indexOf('GTmetrix') == -1 && window['\x6E\x61\x76\x69\x67\x61\x74\x6F\x72']['\x75\x73\x65\x72\x41\x67\x65\x6E\x74'].indexOf('pingbot') == -1) {
$(document).on('change', '.option-select', function () {
    let $variant = $(this).closest('.variant-select-cont');
    let map = {};
    let o = [];

    $variant.find('.option-select').each(function () {
        map[$(this).attr('name')] = $(this).val();
    });
    let available_options = window.variants.filter((i) => (i.available));

    o['option1'] = available_options
        .filter((item) => ((item.option2 == map.option2)))
        .map((item) => item['option1']);
    o['option2'] = available_options
        .filter((item) => ((item.option1 == map.option1)))
        .map((item) => item['option2']);

    // Enable only options available with the selected option
    for (let i = 1; i <= 2; i ++) {
        let arr = o['option'+i];
        let selector = '[name=dropdownoptions'+i+']';
        let selected_disabled = false;

        $(selector).children('.dropdown-item').each(function() {
            var option_name = '';
            var value = $(this).attr('value')
            if ($.inArray(value, arr) > -1) {
                //$(this).attr('disabled', false);
                option_name = $(this).attr('value').split('(')[0];
                $(this).text(option_name);
                $(this).removeClass('not-available');
            } else {
                //$(this).attr('disabled', true);
                option_name = $(this).attr('value') + ' (Sold Out)';
                $(this).text(option_name);
                $(this).addClass('not-available');
                if ($(this).is(':selected'))
                    selected_disabled = true;
            }
        });

        var $custom_selector = $(selector).parent().find('.select-items');
        var $customer_selected = $(selector).parent().find('.select-selected');
        var selected_text = $($customer_selected)[0];
        var x = 0;
        $($custom_selector).children('div').each(function() {
            var option = $(selector).children('option')[x];
            var text = $(option).text();
            $(this).text(text);
            //if (text.includes('Sold Out')) 
            if (text.indexOf("Sold Out") >= 0)
                $(this).addClass('not-available');
            else
                $(this).removeClass('not-available');
            //if(($(selected_text).text()).includes(text.split(' (Sold Out)')[0]))
            if(($(selected_text).text()).indexOf(text.split(' (Sold Out)')[0]) >= 0)
                $(selected_text).text(text);
            x ++;
        });
    }

    let match_found = false;
    for (let i = 0, l = window.variants.length; i < l; i++) {
        let variant = window.variants[i];
        let matches = true;

        for (let key in map) {
            if (map.hasOwnProperty(key)) {
                matches &= variant[key] === map[key];
            }
        }
        if (matches) {
            $variant.find('#variants').val(variant.id).change();
            match_found = true;
            break;
        }
    }
    if (!match_found) {
        console.log('no match')
    }
});

$('.variant-select-cont .option-select').first().trigger('change');

$(document).on('change', '.id-select', function() {
    window.variant_id = $(this).val();
    let variant = window.variants.find(v => (v.id + '') === variant_id);

    if (variant != null) {
        $('.product-details .afterpay-price').html(Shopify.formatMoney(variant.price / 4));
        var compareAtElement = $('.compare-at-price');
        var priceElement = $('.price');
        var price = Shopify.formatMoney(variant.price, Shopify.money_without_currency_format);

        if (variant.compare_at_price > variant.price) {
            var compare = Shopify.formatMoney(variant.compare_at_price, Shopify.money_without_currency_format);
            compareAtElement.removeClass('is-hidden');
            compareAtElement.html(compare);
            priceElement.html(price);
        } else {
            compareAtElement.addClass('is-hidden');
            priceElement.html(price);
        }

        $('.laybuy-price').html(Shopify.formatMoney(variant.price / 6, Shopify.money_without_currency_format));
        $('.afterpay-price').html(Shopify.formatMoney(variant.price / 4, Shopify.money_without_currency_format));
        // var variantName = variant.name;
        // $('.product-title').html(variantName); 
    }
});

$('.size-guide-button').on('click', function() {
  $('#size-guide.modal').addClass('is-active');
})

$('.laybuy-button').on('click', function() {
  $('#laybuy-modal').addClass('is-active');
})

$('.afterpay-button').on('click', function() {
  $('#afterpay-modal').addClass('is-active');
})

$('.zip-button').on('click', function() {
  $('#zip-modal').addClass('is-active');
})

////////////////////////////////
///////// Dropdown
////////////////////////////////

$('.dropdown-trigger').on('click', function() {
    $(this).closest('.dropdown').toggleClass('is-active');
})

$('.dropdown-item').on('click', function() {
    if ($(this).hasClass('not-available'))
        return
    var value = $(this).attr('value');
    var label = $(this).attr('label');
    var select = $(this).closest('.dropdown-container').find('select');
    $(this).siblings().removeClass('is-active');
    $(this).addClass('is-active');
    if (label)
        $(this).closest('.dropdown').find('.option-title').html(label)
    else
        $(this).closest('.dropdown').find('.option-title').html(value)
    $(this).closest('.dropdown').removeClass('is-active');
    select.val(value).trigger('change');
})

////////////////////////////////
///////// Accordian
////////////////////////////////

$('.accordian-trigger, .question-trigger').on('click', function() {
    $(this).next().slideToggle();
    $(this).find('.wb-icon').toggleClass('wb-plus').toggleClass('wb-minus')
})

////////////////////////////////
///////// Modal
////////////////////////////////

$('.modal-background, .modal-close-button').on('click', function() {
    $(this).closest('.modal').removeClass('is-active');
})

////////////////////////////////
///////// Mobile menu dropdown
////////////////////////////////

$('.mobile-links .navbar-item.has-dropdown .navbar-link').on('click', function() {
    $(this).parent().toggleClass('open')
    $(this).next().slideToggle()
    $(this).find('.wb-icon').toggleClass('wb-plus').toggleClass('wb-minus')
})

window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
    element: null,
    template: null,
    data: {},

    /**
     * Browser cookies are required to use the cart. This function checks if
     * cookies are enabled in the browser.
     */
    cookiesEnabled: function() {
        var cookieEnabled = navigator.cookieEnabled;

        if (!cookieEnabled) {
            document.cookie = 'testcookie';
            cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
        }
        return cookieEnabled;
    },

    reloadCart: function (data, syncCampaign) {
        if (typeof data !== 'undefined' && typeof data.items !== 'undefined') {
            slate.cart.data = data;
            $('.cart-item-count').html(`(${slate.cart.data.item_count})`);

            slate.cart.render();
        } else {
            $.ajax({
                url: '/cart.js',
                type: 'get',
                dataType: 'json'
            }).done(function (data) {
                slate.cart.data = data;
                $('.cart-item-count').html(`(${slate.cart.data.item_count})`);
                slate.cart.render();

                if (syncCampaign) {
                    slate.cart.syncCampaign(data);
                }
            });
        }
    },

    render: function () {
        let cart_item_template = Handlebars.compile($('#cart-item-template').html());
        let html = cart_item_template({
            shop: Shopify,
            products: slate.cart.data.items
        });
        slate.cart.element.find('.cart-items').html(html);

        var formatted = Shopify.formatMoney(slate.cart.data.total_price, Shopify.money_without_currency_format)
        slate.cart.element.find('.cart-subtotal').html(formatted);
    },

    open: function () {
        slate.cart.element.addClass('shown');
        slate.cart.overlay.stop().fadeIn(4000);
    },

    close: function () {
        slate.cart.element.removeClass('shown');
        slate.cart.overlay.stop().fadeOut(300);
    },

    update: function () {
        var promises = [];

        for (var i = 0, l = slate.cart.data.items.length; i < l; i++) {
            var item = slate.cart.data.items[i];
            var quantity = parseInt($('#cart-' + item.id + '-quantity').val());

            if (item.quantity !== quantity) {
                promises.push($.ajax({
                    url: '/cart/change.js',
                    type: 'post',
                    dataType: 'json',
                    data: {
                        id: item.id,
                        quantity: quantity
                    }
                }));
            }
        }

        if (promises.length > 0) {
            slate.cart.element.addClass('loading');

            $.when.apply($, promises).then(function (responses) {
                var data = responses;
                if (promises.length > 1) {
                    data = responses[0];
                }

                slate.cart.element.removeClass('loading');
                slate.cart.reloadCart(data);

                // theme.toast(theme.strings.cartUpdated);

                $('.add-to-cart.checkout').html(function () {
                    return $(this).data('buttonText');
                }).removeClass('checkout').attr('disabled', false);
            });
        }
    }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  },
    getUrlParam: function (key, default_value) {
        var query = window.location.search.substring(1);
        var vars = query.split('&');
        var query_string = {};

        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split('=');
            if (typeof query_string[pair[0]] === 'undefined') {
                query_string[pair[0]] = decodeURIComponent(pair[1]);
            } else if (typeof query_string[pair[0]] === 'string') {
                query_string[pair[0]] = [query_string[pair[0]], decodeURIComponent(pair[1])];
            } else {
                query_string[pair[0]].push(decodeURIComponent(pair[1]));
            }
        }

        var value = query_string[key];
        if (typeof value === 'undefined') {
            return default_value;
        }

        return value;
    }
};

function get_section_name(event) {
    var section = null;
    if (event && event.detail) {
        var data = {};
        var dataset = event.target.dataset;
        for (var key in dataset) {
            if (dataset.hasOwnProperty(key) && key.indexOf('themeEditorSection-') === 0) {
                data = JSON.parse(dataset[key]);
            }
        }
        if (data.hasOwnProperty('type')) {
            section = data['type'];
        }
    }
    return section;
}

document.addEventListener("DOMContentLoaded", onload);
/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');
      
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

slate.Slideshow = (function() {
    function slideshow(el, settings) {
        this.$slideshow = $(el);
        this.settings = settings;
        this.$container = this.$slideshow.find('.swiper-container');

        if (this.$container.length > 0) {
            this.swiper = new Swiper(this.$container.get(0), this.settings);
        }
    }

    return slideshow;
})();

slate.slideshows = {};

slate.SlideshowSection = (function() {
    function SlideshowSection(container) {
        let $container = this.$container = $(container);
        let sectionId = this.slideshow = $container.attr('data-section-id');
        if ($container.children('.content-inner').length > 0)
            $container = this.$container = $container.children('.content-inner');
        let settings = $container.find('.swiper-container').data('swiper');

        slate.slideshows[sectionId] = new slate.Slideshow($container, settings);
    }

    return SlideshowSection;
})();

slate.SlideshowSection.prototype = $.extend({}, slate.SlideshowSection.prototype, {
    onUnload: function() {
        slate.slideshows[this.slideshow].swiper.destroy();
        delete slate.slideshows[this.slideshow];
    },

    onBlockSelect: function(evt) {
        let $slide = $('#slideshow-slide-' + evt.detail.blockId);
        let $swiper = slate.slideshows[this.slideshow].swiper;

        $swiper.slideTo($slide.index());
        $swiper.stopAutoplay();
    },

    onBlockDeselect: function() {
        let $slideshow = slate.slideshows[this.slideshow];

        if ($slideshow.settings.autoplay) {
            $slideshow.swiper.startAutoplay();
        }
    }
});

$(document).ready(function() {
    let sections = new slate.Sections();
    sections.register('slideshow-section', slate.SlideshowSection);
});
/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
  var moneyFormat = '$';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    value = formatWithDelimiters(cents, 2);

    // switch (formatString.match(placeholderRegex)[1]) {
    //   case 'amount':
    //     value = formatWithDelimiters(cents, 2);
    //     break;
    //   case 'amount_no_decimals':
    //     value = formatWithDelimiters(cents, 0);
    //     break;
    //   case 'amount_with_space_separator':
    //     value = formatWithDelimiters(cents, 2, ' ', '.');
    //     break;
    //   case 'amount_no_decimals_with_comma_separator':
    //     value = formatWithDelimiters(cents, 0, ',', '.');
    //     break;
    //   case 'amount_no_decimals_with_space_separator':
    //     value = formatWithDelimiters(cents, 0, ' ');
    //     break;
    // }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    console.log('singleOptionSelector', this.singleOptionSelector)
    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();
      console.log('onSelectChange')

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();

$(document).ready(function () {
    slate.cart.element = $('#cart');
    slate.cart.overlay = $('#cart-overlay');
    slate.cart.template = Handlebars.compile(slate.cart.element.find('#cart-item-template').html());

    $(document).on('click', '#cart .product-item-qty button', function () {
        var $qty = $(this).siblings('[name="quantity"]');
        var val = parseInt($qty.val());

        if ($(this).hasClass('qty-minus')) {
            val = Math.max(0, val - 1);
        } else {
            val = Math.min(99, val + 1);
        }

        $qty.val(val);
        $(this).siblings('.qty-val').html(val);
    });

    $(document).on('click', '#cart .product-item-qty button', _.debounce(function () {
        slate.cart.update();
    }, 500));

    $(document).on('click', '#cart-btn', function(event) {
        event.preventDefault();
        slate.cart.open();
    });

    slate.cart.element.find('.cart-close').click(function (event) {
        event.preventDefault();
        slate.cart.close();
        return false;
    });

    slate.cart.overlay.click(function () {
        slate.cart.close();
        $('#shade-selector').stop().fadeOut(300);
    });

    slate.cart.reloadCart();
});

function load_youtube(element) {
    var autoplay = element.dataset.videoAutoplay === "true",
        mute = element.dataset.videoMute === "true",
        loop = element.dataset.videoLoop === "true",
        $element = $(element),
        $parent = $(element).parent(),
        $overlay = $element.closest('.video-section').find('.video-overlay');

    player = new YT.Player(element.id, {
        width: 746,
        videoId: element.dataset.videoLink,
        playerVars: {
            showinfo: 0,
            modestbranding: 0,
            rel: 0
        },
        events: {
            onReady: function (event) {
                var video = event.target;
                if (autoplay) {
                    $parent.data('pausedAutomatically', true);
                }
                if (mute) {
                    video.mute();
                }
            },
            onStateChange: function (event) {
                if (event.data === YT.PlayerState.PLAYING) {
                    if (!autoplay) {
                        $overlay.addClass('active');
                    }
                    $parent.data('pausedAutomatically', false);
                }

                if (event.data === YT.PlayerState.ENDED && loop) {
                    event.target.playVideo();
                }
            }
        }
    });
}

function load_youtube_all() {
    $('.youtube-video').each(function (index, el) {
        load_youtube(el);
    });
}

function load_youtube_api() {
    if (!document.querySelector('.youtube-video')) {
        // No youtube elements, do not load youtube API
        return;
    }

    if (!document.querySelector('#youtube_api')) {
        // Youtube API is not yet loaded, create script that loads it
        create_script("youtube_api", "https://www.youtube.com/player_api");

        // Call 'youtube_load_all' as soon as the API is loaded
        window.onYouTubePlayerAPIReady = load_youtube_all;
    } else if (!window.YT) {
        // Script for loading youtube API is there, but youtube is not yet loaded,
        // load_youtube_all will be called when script finishes loading
    } else {
        // We already have youtube API loaded, call 'load_youtube_all'
        load_youtube_all();
    }
}

function load_vimeo(element) {
    var player = new Vimeo.Player(element.id);
    player.ready().catch(function (e) {
        document.getElementById(element.id).innerText = e;
    });
    if (document.querySelector('#' + element.id).dataset.videoMute === "true") {
        player.setVolume(0);
    }
    var autoplay = element.dataset.videoAutoplay === 'true';
    if (autoplay) {
        $(element.parentNode).data('pausedAutomatically', true);
    }

    var $element = $(element),
        $parent = $element.parent(),
        $overlay = $element.closest('.video-section').find('.video-overlay');

    visibility_tracker(
        $parent,
        function scrolled_into_view() {
            if ($parent.data('pausedAutomatically')) {
                player.play();
            }
        },
        function scrolled_out_of_view() {
            $overlay.removeClass('active');
            player.getPaused().then(function (paused) {
                if (!paused) {
                    player.getEnded().then(function (ended) {
                        if (!ended) {
                            $parent.data('pausedAutomatically', true);
                            player.pause();
                        }
                    });
                }
            });
        }
    );
    player.on('play', function(data) {
        if (!autoplay) {
            $overlay.addClass('active');
        }
        $parent.data('pausedAutomatically', false);
    });

}

function load_vimeo_all() {
    $('.vimeo-video').each(function (index, el) {
        load_vimeo(el);
    });
}

function load_vimeo_api() {
    if (!document.querySelector('.vimeo-video')) {
        // No vimeo elements, do not load vimeo API
        return;
    }

    if (!document.querySelector('#vimeo_api')) {
        // Vimeo API is not yet loaded, create script that loads it
        var script = create_script("vimeo_api", "https://player.vimeo.com/api/player.js");

        if (script.readyState) {
            // IE
            script.onreadystatechange = function() {
                if (element.readyState == "loaded" || element.readyState == "complete") {
                    element.onreadystatechange = null;
                    load_vimeo_all();
                }
            };
        } else {
            // Other browsers
            script.onload = function() {
                load_vimeo_all();
            };
        }
    } else if (!window.Vimeo) {
        // Script for loading vimeo API is there, but vimeo is not yet loaded,
        // load_vimeo_all will be called when script finishes loading
    } else {
        // We already have vimeo API loaded, call 'load_vimeo_all'
        load_vimeo_all();
    }
}

function create_script(id, src) {
    var tag = document.createElement('script');
    tag.id = id;
    tag.src = src;
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    return tag;
}

function makeVideoEmbedsResponsive() {

    $('.template-page iframe, .template-blog iframe, .template-article iframe').each(function(index, iframe) {
        var source = $(iframe).attr("src");
        if (source.indexOf("youtube.com") >= 0 || source.indexOf("vimeo.com") >= 0 || source.indexOf("dailymotion.com") >= 0) {
            //create container
            var embedContainer = document.createElement('div');
            $(embedContainer).addClass('embed-container');
            //clone iframe
            var iframeClone = $(iframe).clone();
            //put clone in container
            $(embedContainer).append(iframeClone);
            //embed clone with responsive container
            $(iframe).replaceWith(embedContainer);
        }
    });
}

$(document).ready(function() {
    makeVideoEmbedsResponsive();
    load_youtube_api();
    load_vimeo_api();
});

/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = (function() {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));

    if (this.$featuredImage.length > 0) {
      this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
      slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
    }
  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;

      if (!variant) {variant = window.variant}

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      if (variant.available) {
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */


    updateProductPrices: function(evt) {
      /*
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      $(selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }*/
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

      this.$featuredImage.attr('src', sizedImgUrl);
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Product;
})();

$(document).on('click', '.description-buttons span:not(.selected)', function() {
    $('.description-buttons span').toggleClass('selected');
    $('.product-description, .product-features').toggleClass('hidden');
});

$(document).on('click', '.thumbnail', function() {
    var new_image = $(this).attr('data-fullsize-img');
    var image = $('.main-image img');
    $(image).attr('src', new_image);
});

$('form.checkout-form').submit(function(event) {
    event.preventDefault();

    var variant_id = $(this).find('#variants').val();
    var $button = $(this).find("[type=submit]");

    if ($button.hasClass('disabled')) {
        $('.oos-link').click();
    } else if (variant_id) {
        var $span = $button.find('span').html('Adding to Cart');
        $button.prop('disabled', true);

        Shopify.onError = function(e) {
            $button.prop('disabled', false);
            $span.html('Add Item To Cart');

            if (e.responseJSON) {
                if (e.responseJSON.status === 422) {
                    var modal_id = 'variant-sold-out';
                    var modal_elem = $('#' + modal_id);
                    if (modal_elem.length > 0) {
                        if (modal_elem.modal('status') !== 'initialized') {
                            modal_elem.appendTo('body');
                        }

                        modal_elem.modal('open', modal_id);
                        modal_elem.focus();

                        return modal_elem.keyup(function (event) {
                            // Close the modal on Esc key.
                            if (event.keyCode === 27) {
                                event.preventDefault();
                                modal_elem.modal('close');
                                return false;
                            }
                        });
                    }
                } else {
                    //return Shopify.cartNotice(e.responseJSON.description);
                }
            }
        };

        var properties = {};
        $(this).find('.option-field').each(function () {
            properties[$(this).attr('name')] = $(this).val();
        });

        Shopify.addItem(variant_id, 1, function(n) {
            $button.prop('disabled', false);
            $span.html('Add Item To Cart');
            slate.cart.reloadCart();
            window.openCart();
        }, properties);
    }

    return false;
});

// left: 37, up: 38, right: 39, down: 40,
// spacebar: 32, pageup: 33, pagedown: 34, end: 35, home: 36
var keys = {37: 1, 38: 1, 39: 1, 40: 1};
var mobile_swiper;

function preventDefault(e) {
    e = e || window.event;
    if (e.preventDefault)
        e.preventDefault();
    e.returnValue = false;
}

function preventDefaultForScrollKeys(e) {
    if (keys[e.keyCode]) {
        preventDefault(e);
        return false;
    }
}

function disableScroll() {
    if (window.addEventListener) // older FF
        window.addEventListener('DOMMouseScroll', preventDefault, false);
    window.onwheel = preventDefault; // modern standard
    window.onmousewheel = document.onmousewheel = preventDefault; // older browsers, IE
    window.ontouchmove  = preventDefault; // mobile
    document.onkeydown  = preventDefaultForScrollKeys;
}

function enableScroll() {
    if (window.removeEventListener)
        window.removeEventListener('DOMMouseScroll', preventDefault, false);
    window.onmousewheel = document.onmousewheel = null;
    window.onwheel = null;
    window.ontouchmove = null;
    document.onkeydown = null;
}

var container = $('.image-container');
var default_image = container.find('img').attr('src');
var default_text = container.find('span').text();
var default_link = container.find('a').attr('href');
var menu_hovered = false;

$('.site-nav--has-submenu').on({
    mouseenter: function() {
        menu_hovered = true;
        $(this).find('.site-nav__submenu').slideDown(200);
        $(this).find('.nav-site-overlay').addClass('shown');
        $(this).find('.nav-site-overlay').addClass('hovered');
        $(this).find('.site-nav__submenu').removeClass('hidden');
        container = $(this).find('.image-container');
        default_image = container.find('img').attr('src');
        default_text = container.find('span').text();
        default_link = container.find('a').attr('href');
        disableScroll();
    },
    mouseleave: function() {
        menu_hovered = false;
        var $menu = $(this);
        function hide() {
            if (!menu_hovered)
                $menu.find('.site-nav__submenu').slideUp(0);
        }
        setTimeout(hide, 200);
        $(this).find('.nav-site-overlay').removeClass('hovered');
        $menu.find('.nav-site-overlay').removeClass('shown');
        $(this).find('.site-nav__submenu').addClass('hidden');
        container.find('img').attr('src', default_image);
        container.find('span').text(default_text);
        container.find('a').attr('href', default_link);
        enableScroll();
    }
});

var calculateHeaderSpacing = function() {
    var headerHeight = $('#shopify-section-header .navbar').height();

    if ($(window).width() < 990) {
        var data = sessionStorage.getItem('hideMobileMessage');
        if (!data) {
            $('.mobile-message').css('display', 'none');
            $('.mobile-links').addClass('no-message-bar');
        }
        var maxHeight = `calc(100vh - ${headerHeight}px - 100px)`
        $('.cart-panel').css('max-height', maxHeight)
    } else {
        $('#main').css('margin-top', "0px");
        var maxHeight = `calc(100vh - ${headerHeight}px)`
        $('.cart-panel').css('max-height', maxHeight)
    }
}

var showFilterOnDesktop = function() {
    if ($(window).width() > 1024) {
        $('#filter').show();
    }
}

$('.mobile-filter-dropdown').on('click', function() {
    $('#filter').slideToggle();
})

calculateHeaderSpacing();
showFilterOnDesktop();

$(window).resize(function() {
    calculateHeaderSpacing();
});

$(document).on('click', '.mobile-message .close-btn', function() {
    sessionStorage.setItem('hideMobileMessage', true);
    $('.mobile-message').slideUp();
    $('.mobile-links').addClass('no-message-bar');
});

// Mobile menu toggle
$(document).on('click', 'header .hamburger-button', function() {
    var navOpen = !$(this).hasClass('open');
    $(this).toggleClass('open');
    $('.mobile-nav').toggleClass('open')

    if (navOpen)
        $('.cart-panel').removeClass('shown')
});

$.fn.modal = function(action, param) {
    if (action == null) { action = 'open'; }
    let $this = this;
    let footer_form = $('#mc-embedded-subscribe-form').first();

    if (action === 'open') {
        if (param) {
            push_data({
                event: 'openPopup',
                label: param
            });
        }

        if ($this.find('.close-button').length === 0) {
            let $button = $('<button class="close-button close-modal"><svg aria-hidden="true" data-prefix="fas" data-icon="times" class="svg-inline--fa fa-times fa-w-11" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 352 512"><path fill="currentColor" d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"></path></svg></button>').click(() => $this.modal('close'));

            $this.find('.modal-inner').prepend($button);

            $this.click(function(event) {
                if ($(event.target).closest('.modal-inner').length === 0) {
                    return $this.modal('close');
                }
            });
        }

        footer_form.attr("id", "footer-form");
        footer_form.attr("name", "footer-form");

        $this.hide().addClass('shown').stop().fadeIn(200);
    } else if (action === 'close') {
        $this.stop().fadeOut(200, function() {
            $this.modal('load', false);
            footer_form.attr("id", "mc-embedded-subscribe-form");
            footer_form.attr("name", "mc-embedded-subscribe-form");
            return $this.removeClass('shown');
        });
    } else if (action === 'load') {
        if (param) {
            $this.$loader = $('<div class="overlay" />').addLoader(0);
            $this.find('.modal-inner').append($this.$loader);
        } else {
            try {
                $this.$loader.remove();
            } catch (error) {
                return $this;
            }
        }
    } else if (action === 'status') {
        return $this.data('status');
    }

    $this.data('status', 'initialized');

    return $this;
};

window.modal_events = () =>
$(document).on('click', '[data-modal]', function(event) {
    event.preventDefault();

    let modal_id = $(this).data('modal');
    let modal_elem = $(`#${modal_id}`);
    if (modal_elem.length > 0) {
        if (modal_elem.modal('status') !== 'initialized') {
            modal_elem.appendTo('body');
        }

        modal_elem.modal('open', modal_id);
        modal_elem.focus();

        return modal_elem.keyup(function(event) {
            // Close the modal on Esc key.
            if (event.keyCode === 27) {
                event.preventDefault();
                modal_elem.modal('close');
                return false;
            }
        });
    }
});

$(document).ready(function() {
    modal_events();

    let $modals = $('.modal');
    let resize_tables = () =>
    $modals.each(function() {
        return $(this).find('table').css({
            'max-width': ($(window).width() - 60)});
    })
    ;

    $(window).resize(_.throttle(resize_tables, 200));
    return resize_tables();
});

/*================ Templates ================*/
$(document).ready(function() {
    if ($('body').hasClass('template-blog')) {
        var page = parseInt(slate.utils.getUrlParam('page', 1));
        var template = Handlebars.compile($('#blog-articles [type="text/x-handlebars-template"]').html());

        var $articles = $('#articles');

        $('#blog-pagination-btn').click(function () {
            var $this = $(this);
            var buttonText = $this.attr('disabled', true).html();
            // TODO: string not part of theme obj yet
            $this.html(theme.strings.loading);

            var pages = parseInt($(this).data('pages'));
            page++;

            $.ajax({
                url: location.url,
                type: 'get',
                dataType: 'json',
                data: {
                    page: page,
                    view: 'ajax'
                }
            }).done(function (response) {
                var articles = [];
                var $lastArticle = $articles.find('> .article-section:last');
                var klass = $lastArticle.hasClass('half-posts') ? 'full-post' : 'half-posts';
                var flipClass = false;

                for (var i = 0, l = response.length; i < l; i++) {
                    if (flipClass) {
                        if (klass === 'half-posts') {
                            klass = 'full-post'
                        } else {
                            klass = 'half-posts'
                        }
                        flipClass = false;
                    }
                    var article = response[i];
                    articles.push(template(article));

                    if ((klass === 'full-post' && articles.length === 1) || (klass === 'half-posts' && articles.length === 2)) {
                        $lastArticle.after('<div class="article-section ' + klass + '">' + articles.join('') + '</div>');
                        articles = [];
                        flipClass = true;
                    }
                }

                if (page >= pages) {
                    $this.parent().remove();
                } else {
                    $this.attr('disabled', false).html(buttonText);
                }
            });
        });
    }
});

/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();


/*================ Modules ================*/
function iOS() {

    var iDevices = [
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod'
    ];

    if (!!navigator.platform) {
        while (iDevices.length) {
            if (navigator.platform === iDevices.pop()){ return 1; }
        }
    }

    return 0;
}

var playerVars = {
    modestbranding: 1,
    autohide: 2,
    showinfo: 0,
    controls: iOS(),
    enablejsapi: 0,
    playsinline: 1,
    rel: 0,
    fs: 0
};

$(document).ready(function () {
    var timeout;

    $('.video button').click(function (event) {
        event.preventDefault();

        var $this = $(this);
        var $video = $(this).closest('.video');
        var videoId = $video.data('video');

        var $playerFrame = $('<div class="video-frame"><div class="video-frame-inner"><div class="v"></div></div></div>').appendTo($video).hide();
        $video.addClass('fadeOut');
        $this.fadeOut(300);
        var $stopButton = $playerFrame.find('.stop-video');

        var player = new YT.Player($playerFrame.find('.v').get(0), {
            videoId: videoId,
            playerVars: playerVars,
            events: {
                onReady: function (event) {
                    $playerFrame.fadeIn(300, function () {
                        event.target.playVideo();
                    });
                }
            }
        });

        if (iOS() === 1) {
            $playerFrame.find('.v').addClass('iphone');
        }

        $stopButton.click(function (event) {
            event.preventDefault();

            $this.fadeIn(200);
            $playerFrame.fadeOut(200, function () {
                $(this).remove();
            });

            return false;
        });

        return false;
    });

    var player = null;

    $('.video-btn.js-btn').click(function (event) {
        event.preventDefault();
        var $this = $(this);

        if (! $this.hasClass('active')) {
            $this.addClass('active');
            var $video = $(this).parent().parent().find('.video');
            var videoId = $video.data('video');
            var $playerFrame = $('<div class="video-frame"><div class="video-frame-inner"><div class="v"></div></div></div>').appendTo($video).hide();
            $video.addClass('fadeOut');
            var $stopButton = $playerFrame.find('.stop-video');

            player = new YT.Player($playerFrame.find('.v').get(0), {
                videoId: videoId,
                playerVars: {
                    modestbranding: 1,
                    autohide: 1,
                    showinfo: 0,
                    enablejsapi: 1,
                    playsinline: 1,
                    rel: 0,
                    fs: 0
                },
                events: {
                    onReady: function (event) {
                        $playerFrame.fadeIn(300, function () {
                            event.target.playVideo();
                        });
                    },
                    onStateChange: function(event) {
                        if (event.data === 0) {
                            $this.removeClass('active');
                            $playerFrame.addClass('fadeOut');
                        }
                    }
                }
            });

            $stopButton.click(function (event) {
                event.preventDefault();

                $this.fadeIn(200);
                $playerFrame.fadeOut(200, function () {
                    $(this).remove();
                });

                return false;
            });

            return false;
        }
    });
});

$(document).ready(function() {
  var sections = new slate.Sections();
  sections.register('product', theme.Product);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Target tables to make them scrollable
  var tableSelectors = '.rte table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper',
  });

  // Target iframes to make them responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper'
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }
});

$(document).ready(function() {
    let is_sidebar = false;
    let $js_cart = $('.js-cart');
    let $cart = null;
    let $subtotal = null;
    let $cartButton = $('[data-open-cart]');
    let cart_item_template = Handlebars.compile($('#cart-item-template').html());
    let update_id = null;

    window.update_cart = function() {
        let $input;
        let u_id = update_id;

        if (is_sidebar) {
            $input = $cart.find(`.cart-item[data-id="${u_id}"]`).find('.q-input');
        } else {
            $input = $cart.find(`.cart-item[data-id="${u_id}"]`).find('.q-input');
        }

        let quantity = parseInt($input.val());

        if (!isNaN(quantity)) {
            return Shopify.changeItem(u_id, quantity, function(cart) {
                Shopify.onCartUpdate(cart);

                $subtotal.html(Shopify.formatMoney(cart.total_price));

                let $ci = $input.closest('.cart-item');
                $ci.find('.qty').html(quantity);

                if (quantity === 0) {
                    return $input.closest('.cart-item').slideUp(200, function() {
                        $(this).remove();

                        if ($cart.find('.cart-item').length === 0) {
                            $cart.find('.cart-inner').hide();
                            return $cart.find('.no-items').fadeIn(200);
                        }
                    });
                } else {
                    return (() => {
                        let result = [];
                    for (let item of cart.items) {
                        if (item.id == u_id) {
                            $ci.find('.line-price').html(Shopify.formatMoney(item.line_price));

                            if (item.quantity !== quantity) {
                                $input.val(item.quantity);
                                $input.tooltipster('content', `The maximum quantity of this item is ${item.quantity}`).tooltipster('show');

                                setTimeout(function() {
                                    $input.tooltipster('hide');
                                }, 4000);
                            }

                            break;
                        } else {
                            result.push(undefined);
                        }
                    }

                    return result;
                })();
                }
            });
        }
    };

    let debounced = _.debounce(update_cart, 1000);

    $cartButton.click(function(event) {
        event.preventDefault();

        window.openCart();

        return false;
    });

    window.openCart = function () {
        is_sidebar = false;

        try {
            $('.tool-cart img').tooltipster('hide');
        } catch (error) {}

        $cart = $('#cart');
        $subtotal = $cart.find('.subtotal').find('.price');

        $cart.addClass('shown');
        $('.mobile-nav').removeClass('open');
        $('.hamburger-button').removeClass('open');
        $cart.find('.no-items').hide();

        load_cart();
    };

    $js_cart.find('.cart-close').click(function() {
        $cart.removeClass('shown');
    });

    $js_cart.on('click', '.q-add', function() {
        let $input = $(this).siblings('.q-input:first');
        $input.val(parseInt($input.val(), 10) + 1);

        let item_id = $(this).closest('.cart-item').data('id');
        if (update_id !== item_id) {
            debounced.flush();
        }

        update_id = item_id;
        return debounced();
    });

    $js_cart.on('click', '.q-subtract', function() {
        let $input = $(this).siblings('.q-input');
        $input.val(Math.max(parseInt($input.val(), 10) - 1, 0));

        let item_id = $(this).closest('.cart-item').data('id');
        if (update_id !== item_id) {
            debounced.flush();
        }

        update_id = item_id;
        return debounced();
    });

    $js_cart.on('blur', '.q-input', function() {
        let item_id = $(this).closest('.cart-item').data('id');

        if (update_id !== item_id) {
            debounced.flush();
        }

        update_id = item_id;
        return update_cart();
    });

    $('body').click(function(event) {
        if (!is_sidebar) {
            if ($(event.target).closest('#cart').length === 0) {
                $cart = $js_cart.filter('#cart');
                if ($cart.hasClass('shown')) {
                    $cart.removeClass('shown');
//                    $cart.find('.q-input').tooltipster('hide');
                    $cart.find('.no-items').fadeOut(200);

                    setTimeout(() => $cart.find('.cart-inner').show(), 200);

                    return $('body').removeClass('sidebar');
                }
            }
        }
    });

    window.load_cart = function(sidebar) {
        if (sidebar === null) { sidebar = false; }
        if (sidebar) {
            is_sidebar = true;

            $cart = $('#sidebar-cart');
            $subtotal = $cart.find('.subtotal').find('.price');

            $cart.find('.no-items').hide();
            $('.snap-drawer-right').addClass('drawer-cart');
        }

        window.alert = function() {};

        Shopify.getCart(function(cart) {
            var $subtotal = $('#cart .cart-subtotal')

            if (typeof $subtotal !== 'undefined') {
                $subtotal.html(`<span class=money>${Shopify.formatMoney(cart.total_price)}</span>`);
            }

            Shopify.onCartUpdate(cart);

            if (cart.items.length > 0) {
                $cart.find('.cart-inner').show();

                let html = cart_item_template({
                    shop: Shopify,
                    products: cart.items
                });

                $cart.find('.cart-items').html(html);

            } else {
                $cart.find('.cart-items').hide();
                return $cart.find('.no-items').fadeIn(200);
            }
        });
    };
});}